import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import { initializeGA4 } from '../utils/analytics';

const CookieConsent = ({ show, onClose }) => {
  const [showConsent, setShowConsent] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const { lang } = useSelector(state => state.langReducer);

  useEffect(() => {
    // 페이지 로드 시 GA4 비활성화
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
    
    const hasConsent = Cookies.get('ga_consent');
    if (!hasConsent) {
      setShowConsent(true);
    } else if (hasConsent === 'true') {
      initializeGA4('accepted');
    }
  }, []);

  // show prop이 변경될 때 처리
  useEffect(() => {
    if (show) {
      setShowConsent(true);
    }
  }, [show]);

  const acceptAllCookies = () => {
    Cookies.set('ga_consent', 'true', { expires: 365 });
    setShowConsent(false);
    initializeGA4('accepted');
  };

  const acceptEssentialOnly = () => {
    Cookies.set('ga_consent', 'false', { expires: 365 });
    setShowConsent(false);
    initializeGA4('denied');
  };

  const handleClose = () => {
    setShowConsent(false);
    onClose();
  };

  // 현재 쿠키 설정 상태 표시
  const [currentSettings, setCurrentSettings] = useState({
    analytics: Cookies.get('ga_consent') === 'true'
  });

  const updateSettings = (newSettings) => {
    setCurrentSettings(newSettings);
    if (newSettings.analytics) {
      acceptAllCookies();
    } else {
      acceptEssentialOnly();
    }
    handleClose();
  };

  if (!showConsent) return null;

  return (
    <>
      {(showConsent || show) && (
        <div style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          background: '#fff',
          padding: '16px',
          boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
          zIndex: 9999
        }}>
          <div style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
          }}>
            <p style={{
              margin: 0,
              fontSize: '14px',
              lineHeight: '1.5',
              color: '#333'
            }}>
              {lang === 0 
                ? '당사는 웹사이트의 기능과 사용자 경험 개선을 위해 쿠키를 사용합니다.' 
                : 'We use cookies to improve website functionality and user experience.'}
            </p>

            <div style={{ 
              display: 'flex',
              justifyContent: 'center',
              gap: '10px'
            }}>
              <button 
                onClick={acceptAllCookies}
                style={{
                  padding: '8px 24px',
                  background: '#0066cc',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                {lang === 0 ? '모든 쿠키 허용' : 'Accept All'}
              </button>
              <button 
                onClick={acceptEssentialOnly}
                style={{
                  padding: '8px 24px',
                  background: '#ffffff',
                  border: '1px solid #0066cc',
                  color: '#0066cc',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                {lang === 0 ? '필수 쿠키만 허용' : 'Essential Only'}
              </button>
            </div>

            <p style={{ 
              margin: 0,
              fontSize: '12px',
              color: '#666',
              textAlign: 'center'
            }}>
              {lang === 0 ? (
                <>
                  더 자세한 정보는{' '}
                  <a 
                    href="/Term?termKey=Privacy" 
                    style={{
                      color: '#0066cc',
                      textDecoration: 'underline',
                      cursor: 'pointer'
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.open('/Term?termKey=Privacy', '_blank');
                    }}
                  >
                    개인정보 처리방침
                  </a>
                  을 참조하세요.
                </>
              ) : (
                <>
                  For more information, please refer to our{' '}
                  <a 
                    href="/Term?termKey=Privacy" 
                    style={{
                      color: '#0066cc',
                      textDecoration: 'underline',
                      cursor: 'pointer'
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.open('/Term?termKey=Privacy', '_blank');
                    }}
                  >
                    Privacy Policy
                  </a>
                  .
                </>
              )}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieConsent; 